import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { AuthGate } from "@/features/auth/AuthGate";
import { applyTheme, readTheme } from "@/app/appearance";
import { paths } from "@/app/paths";
import { router } from "@/app/routes";
import "@/styles/global.css";

const container = document.getElementById("root");
if (!container) throw new Error("#root bulunamadı");

applyTheme(readTheme());

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      {/* Nothing renders until the API says who this session belongs to.
          Signing in lands on Ana Sayfa, always: `replace` so the protected
          URL the user bounced off does not sit one Back press away, where it
          would look like the redirect had failed. The gate is above the
          router, so the navigation is issued on the router object rather than
          through a hook. */}
      <AuthGate onAuthenticated={() => router.navigate(paths.home(), { replace: true })}>
        <RouterProvider router={router} />
      </AuthGate>
    </ErrorBoundary>
  </StrictMode>,
);
